<div class="wrapper">
  <div class="cuerpo">
    <form name="entrar" [formGroup]="signerForm" (ngSubmit)="onSubmit()" class="formulario" autocomplete="off">
      <div class="row documento">
        <h2 class="tp-navandu"> INFORMACIÓN DEL DESTINATARIO </h2>
        <div class="flex-row">
          <mat-form-field class="example-full-width">
            <mat-label>Número de documento</mat-label>
            <input type="text" matInput formControlName="idn" required>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Tipo de documento</mat-label>
            <mat-select required formControlName="typeOfIdn">
              <mat-option value="Alias">Alias</mat-option>
              <mat-option value="DNI">DNI</mat-option>
              <mat-option value="NIF">NIF</mat-option>
              <mat-option value="NIE">NIE</mat-option>
              <mat-option value="CIF">CIF</mat-option>
              <mat-option value="PASS">PASS</mat-option>
              <mat-option value="RUC">RUC</mat-option>
              <mat-option value="Cedula">Cedula</mat-option>
              <mat-option value="Otro">Otro</mat-option>
            </mat-select>
            @if (signerForm.controls.typeOfIdn.hasError('required')) {
              <mat-error>
                Tipo de documento <strong>requerido</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="flex-row">
          <mat-form-field>
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="name" required>
            @if (signerForm.controls.name.hasError('required')) {
              <mat-error>
                Nombre <strong>requerido</strong>
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Apellidos</mat-label>
            <input matInput formControlName="lastName" required>
            @if (signerForm.controls.lastName.hasError('required')) {
              <mat-error>
                Apellido <strong>requerido</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="flex-row filatres">
          <div class="phone-group">
            <mat-form-field class="prefix-section">
              <mat-select required formControlName="countryPhone">
                @for (phonePrefix of phonePrefixes; track phonePrefix) {
                  <mat-option [value]="phonePrefix.prefix">
                    {{phonePrefix.code}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="phone">
              <mat-label>Móvil para sms de firma</mat-label>
              <input matInput formControlName="phone">
              @if (signerForm.controls.phone.hasError('required')) {
                <mat-error>
                  Móvil <strong>requerido</strong>
                </mat-error>
              }
              @if (signerForm.controls.phone.hasError('minlength') || signerForm.controls.phone.hasError('maxlength')) {
                <mat-error
                  >
                  Móvil <strong>debe tener 9 caracteres</strong>
                </mat-error>
              }
              @if (signerForm.controls.phone.hasError('pattern')) {
                <mat-error>
                  Móvil <strong>debe ser numérico</strong>
                </mat-error>
              }
            </mat-form-field>
          </div>
          <mat-form-field class="email">
            <mat-label>Email</mat-label>
            <input matInput placeholder="Ex. pat@example.com" formControlName="email">
            @if (signerForm.controls.email.hasError('email') && !signerForm.controls.email.hasError('required')) {
              <mat-error
                >
                Por favor ingrese un correo válido
              </mat-error>
            }
            @if (signerForm.controls.email.hasError('required')) {
              <mat-error>
                Correo <strong>requerido</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>


      </div>
      <div class="enviar">

        <input type="submit" class="boton volver2" value="Guardar">

      </div>
    </form>

  </div>
</div>